var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sectionpicker", class: _vm.input.extraClass },
    [
      _c(
        "span",
        { staticClass: "headline" },
        [
          _vm._v("\n        " + _vm._s(_vm.input.label) + "\n        "),
          _vm.input.helper
            ? _c("HelperBox", { attrs: { text: _vm.input.helper } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inner grid-50w", class: _vm.input.grid },
        [
          _vm.input.sectionPicker
            ? [
                _c(
                  "div",
                  { staticClass: "input", attrs: { type: "checkboxlist" } },
                  [
                    _c("label", [
                      _c(
                        "section",
                        _vm._l(_vm.input.sectionPicker, function (picker) {
                          return _c("label", { staticClass: "radio" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                "data-value": picker.label,
                              },
                              domProps: {
                                checked: _vm.isChecked(
                                  _vm.formValue,
                                  _vm.input.value,
                                  picker.label
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.checkSetNestedValue(
                                    picker.label,
                                    _vm.input.value,
                                    $event
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("small", [_vm._v(_vm._s(picker.label))]),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.input.forms, function (sectionInput, index) {
            return [
              sectionInput.type == "section"
                ? [
                    _vm.isChecked(
                      _vm.formValue,
                      _vm.input.value,
                      sectionInput.sectionPickerKey
                    )
                      ? _c("Section", {
                          attrs: {
                            input: sectionInput,
                            formValue: _vm.formValue,
                          },
                        })
                      : _vm._e(),
                  ]
                : sectionInput.type == "sectionarraysimple"
                ? [
                    _vm.isChecked(
                      _vm.formValue,
                      _vm.input.value,
                      sectionInput.sectionPickerKey
                    )
                      ? _c("SectionArraySimple", {
                          attrs: {
                            input: sectionInput,
                            formValue: _vm.formValue,
                          },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }